<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title"> {{ info.tell_us_about_patient }} </mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <form class="form-container m-10" [formGroup]="advanceForm" (ngSubmit)="submit()" autocomplete="false">
    <app-input
      class="app-input"
      inputType="text"
      [control]="beneficiaryname"
      [group]="advanceForm"
      [placeHolder]="info.patient.placeholder"
      icon="icon-help"
      [hint]="info.patient.hint"
      hintDirection="left"
      [info]="info.patient.popover"
      [errorMessage]="info.patient.error" >
    </app-input>
    <app-select
      [placeHolder]="info.age.placeholder"
      [group]="advanceForm"
      [control]="beneficiaryage"
      [data]="ageGroup"
      [errorMessage]="info.age.error"
      (onChange)="onAgeSelection($event)">
    </app-select>
    <app-intl-input
      *ngIf="askpatientNumber"
      class="intl-input-container"
      [group]="advanceForm"
      [control]="patientNumber"
      [hideSuffixIcon]="false"
      [placeholder]="askpatientNumber"
      [checkCountry]="checkCountry">
      <!-- [checkCountry] -->
    </app-intl-input>
    <!-- Medical alogolia search -->
    <div class="ais-InstantSearch">
      <ais-instantsearch [config]="medicalConfig">
        <div class="searchbox">
          <app-algolia-medical
            [info]="info"
            [label]="info.disease.label"
            [placeholder]="info.disease.placeholder"
            type="medical"
            [control]="selectedDisease"
            [group]="advanceForm"
          >
          </app-algolia-medical>
        </div>
      </ais-instantsearch>
    </div>

    <app-select
    [placeHolder]="info.hosptialisationStatus.placeholder"
    [group]="advanceForm"
    [control]="hospitalisationStatus"
    [data]="hospitalisationStatusData"
    [errorMessage]="info.hosptialisationStatus.error"
    (onChange)="onHSSelection($event)">
    </app-select>

    <!-- Hospital algolia search -->
    <div class="ais-InstantSearch" [hidden]= "selectedHS === 'Does not require hospitalisation'">
      <ais-instantsearch [config]="hospitalConfig">
        <div class="searchbox">
          <app-algolia-hospital
            [placeholder]="info.hospital.placeholder"
            [label]="info.hospital.label"
            type="hospital"
            [control]="selectedHospital"
            [group]="advanceForm"
            [info]="info"
            >
          </app-algolia-hospital>
        </div>
      </ais-instantsearch>
    </div>
    <!-- add city div here -->
    <form class="form-container" [formGroup]="advanceForm" autocomplete="off">
      <mat-form-field class="input-container">
        <input matInput appPlaceAutocomplete placeType="(cities)" [placeholder]="info.city.placeholder" [formControl]="city" (onSelect)="getPlace($event)">
        <mat-icon class="icon-city" matSuffix></mat-icon>
        <mat-error *ngIf="city.invalid">{{info.fieldRequired}}</mat-error>
      </mat-form-field> <!-- City-ends -->
    </form>
    <button id="submitBtn2" style="display: none"></button>
  </form>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <!-- <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()">SAVE AND CONTINUE</button> -->
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{ info.save_and_continue }}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</mat-card-footer>
